import React, { useEffect } from "react";
import "./Privacy_Policy.css";
import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { getPrivacy_Policy } from "../../features/privacypolicy/Slice";
import parse from "html-react-parser";

function PrivacyPolicy() {
  const navigate = useNavigate();

  const privacyPolicy = useSelector(
    (state) => state.privacypolicy.privacypolicy,
  );
  const dispatch = useDispatch();
  useEffect(() => {
    dispatch(getPrivacy_Policy());
  }, []);


  return (
    <section className="privacy-section">
      <div className="top-bar" onClick={() => navigate("/")}>
        <div className="container">
          <span className="back-text">BACK</span>
        </div>
      </div>

      <div className="privacy-header">
        <div className="container">
          <h1 className=" main_head">Privacy Policy</h1>
        </div>
      </div>

      <div className="container">
        <div className="privacy-card">
          <p className="dark_black_text">
            {privacyPolicy?.content ? parse(privacyPolicy?.content) : ""}
          </p>

          {/* <div className="privacy-buttons">
            <button className="accept-btn">Accept</button>
            <button className="decline-btn">Decline</button>
          </div> */}
        </div>
      </div>
    </section>
  );
}

export default PrivacyPolicy;
